import { ScheduleType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';

const ARRIVAL_ORDER_SCHEDULE_TYPES = [ScheduleType.ARRIVAL_ORDER, ScheduleType.LABORATORIAL];

export const isArrivalOrderScheduleType = (scheduleType?: ScheduleType | null): boolean =>
  scheduleType != null && ARRIVAL_ORDER_SCHEDULE_TYPES.includes(scheduleType);
